exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#container{margin-top:115px}", "", {"version":3,"sources":["C:/Users/chris/projetos/prepago/src/components/Extrato.vue"],"names":[],"mappings":"AACA,WACE,gBAAkB,CACnB","file":"Extrato.vue","sourcesContent":["\n#container {\r\n  margin-top: 115px;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f455e12","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Extrato.vue
// module id = 632
// module chunks = 0 11